/**
 * @generated SignedSource<<451cebbc1c7b1a7a5f2d6cbf04cedbb7>>
 * @relayHash 8d4985540123dfcd89bcb11d9d0975cd
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8d4985540123dfcd89bcb11d9d0975cd

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HtmlTag = "HTML";
export type YesNoLabel = "tf" | "yn";
export type ChangeYesNoDetailsInput = {
  answer?: boolean | null;
  bodyItemId: string;
  clientMutationId?: string | null;
  labelType?: YesNoLabel | null;
  prompt?: HtmlInput | null;
  updateAnswer?: boolean | null;
  updateLabelType?: boolean | null;
  updatePrompt?: boolean | null;
};
export type HtmlInput = {
  type: HtmlTag;
  value: string;
};
export type YesNoChangeMutation$variables = {
  input: ChangeYesNoDetailsInput;
};
export type YesNoChangeMutation$data = {
  readonly changeYesNoDetails: {
    readonly bodyItem: {
      readonly answer: any | null;
      readonly id: string;
      readonly info: any;
    };
  } | null;
};
export type YesNoChangeMutation = {
  response: YesNoChangeMutation$data;
  variables: YesNoChangeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ChangeYesNoDetailsPayload",
    "kind": "LinkedField",
    "name": "changeYesNoDetails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BodyItem",
        "kind": "LinkedField",
        "name": "bodyItem",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "info",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "answer",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "YesNoChangeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "YesNoChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "8d4985540123dfcd89bcb11d9d0975cd",
    "metadata": {},
    "name": "YesNoChangeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "22245e2575bbc5b517e9580e9acd5c8a";

export default node;
